
import React from 'react';
import { BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Blog from './components/Blog';
import Contact from './components/Contact';
import Home from  './components/Home';
import Projects from './components/Projects';


const App = () =>{
  return(
    <Router>
      <div>
        <Switch>
          <Route path="/" component={Home} exact />
          <Route path="/contact" component={Contact} exact />
          <Route path="/blog" component={Blog} exact />
          <Route path="/projects" component={Projects} exact />
        </Switch>
      </div>
    </Router>  
  );
}


export default App;
